import React, { useState, useRef, useContext, useEffect } from "react";
import moment from "moment";

import creditCardIcon from "./resources/creditCard.png";
import simulationIcon from "../../common/simulation/simulation.png";
import bankIcon from "./resources/bank.png";
import RangePicker from "../../../components/RangePicker";
import { AppContext } from "../../../AppContext";
import { getMonthIdAndYearFromTime } from "../../Util";

export default function TransactionItemMobile(props) {
    const { updateTransactionSimulation, simulatedTransactions, getTransactionSimulation } = useContext(AppContext);

    const data = {
        id: props.item.id,
        time: props.item.time,
        parsedTime: moment(props.item.time).format("DD-MM-YY"),
        description: props.item.description,
        amount: props.item.amount,
        totalAmount: props.item.totalAmount,
        isCredit: props.item.isCredit,
        type: props.item.type,
        creditCard: props.item.creditCard,
        transactionType: props.transactionType
    };

    useEffect(() => {
        const { monthId, year } = getMonthIdAndYearFromTime(data.parsedTime);
        const relevantSimulatedTransactions = getTransactionSimulation(year, monthId);

        const simulatedTransaction = relevantSimulatedTransactions[data.id];
        if (simulatedTransaction) {
            if (simulatedTransaction.isCredit) {
                setAmount(simulatedTransaction.changedAmount);
            } else {
                setAmount((simulatedTransaction.changedAmount * -1).toString());
            }
            setIsSimulated(true);
        } else {
            setIsSimulated(false);
            setAmount(props.item.amount);
        }
    }, [simulatedTransactions]);

    const [isSimulated, setIsSimulated] = useState(false);
    const [amount, setAmount] = useState(props.item.amount);
    const rangePickerRef = useRef(null);

    const simulate = () => {
        rangePickerRef.current.show();
    };

    const amountColor = data.isCredit ? "#23d188" : "#ed578b";
    const transactionIcon = data.type === "Account" ? bankIcon : creditCardIcon;

    const rangeChanged = (changedAmount) => {
        updateTransactionSimulation({
            id: data.id,
            transactionType: data.transactionType,
            isCredit: data.isCredit,
            originalAmount: data.amount,
            changedAmount: Number(changedAmount),
            time: data.time
        });
    };

    return (
        <div
            onClick={simulate}
            style={{
                display: "flex",
                flexDirection: "row-reverse",
                justifyContent: "space-between"
            }}
        >
            <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                <img
                    src={transactionIcon}
                    style={{
                        height: 35,
                        width: 35,
                        marginRight: 8,
                        resizeMode: "stretch"
                    }}
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        direction: "rtl",
                        marginRight: 10,
                        textWrap: "balance",
                    }}
                >
                    <p
                        style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            maxWidth: 200
                        }}
                    >
                        {data.description}
                    </p>
                    {/*<p style={{color: "darkgray", fontWeight: "bold", fontSize: 15}}>{data.time}</p>*/}
                </div>
            </div>

            <RangePicker
                data={data}
                amount={Math.abs(amount)}
                max={Math.abs(data.amount)}
                ref={rangePickerRef}
                rangeChanged={rangeChanged}
            />

            <p
                style={{
                    color: amountColor,
                    marginLeft: 20,
                    marginTop: 5,
                    fontSize: 18,
                    fontWeight: "bold",
                    display: "flex"
                }}
            >
                {amount}
                {isSimulated && <img src={simulationIcon} style={{ textAlign: "center", verticalAlign: "middle", height: "15px", marginTop: "15%", marginLeft: "20%" }} />}
            </p>
        </div>
    );
}
